import React, { useState } from 'react';
import { contact } from '../../../../../../models/entities/businessPartner/contact';
import CustomModal, { ModalTriggerProps } from '../../../../../shared/Modal/Modal';
import { styled } from '../../../../../shared/Theme/theme';
import ContactFormConnected, { formMode } from '../../../../businessPartners/singleBusinessPartner/ContactForm/ContactFormConnected';

type Props = {
    submitCallback?: (contact: contact) => void;
    modalTitle: string;
    businessPartnerId: string;
};
const CreateBusinessPartnerContact = ({ submitCallback, modalTitle, businessPartnerId }: Props) => {
    const [modalVisible, setModalVisible] = useState(false);
    return (
        <CustomModal
            title={{ text: modalTitle }}
            isOpen={modalVisible}
            Trigger={(props: ModalTriggerProps) => (
                <AddButton className="material-icons" onClick={() => setModalVisible(true)}>
                    add
                </AddButton>
            )}
            Content={(setVisible?: React.Dispatch<React.SetStateAction<boolean>>, setConfirm?: React.Dispatch<React.SetStateAction<boolean>>) => {
                return (
                    <ContactFormConnected
                        mode={formMode.NEW}
                        openedFromModal={setVisible ? { setVisible } : undefined}
                        confirmation={setConfirm ? { setConfirm } : undefined}
                        submitCallback={submitCallback}
                        businessPartnerId={businessPartnerId}
                    />
                );
            }}
            onCancelCallback={() => setModalVisible(false)}
            width="393px"
        />
    );
};
const AddButton = styled.span`
    color: ${(props) => props.theme.colors.primaryBlue};
    cursor: pointer;
    display: flex;
    align-items: center;
`;
export default CreateBusinessPartnerContact;
